import ApiService from '@/services/apiService';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import pullAt from 'lodash/pullAt';
import isEqual from 'lodash/isEqual';
export default {
  name: 'NiotaClassicGwMgmtAlertConfigs',
  props: {
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      formValid: false,
      unsavedPrompt: false,
      mailBridges: [],
      isLoading: true,
      alertConfigs: [],
      deletedConfigs: [],
      savedAlertConfigs: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions']),
    requiredRule() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired')];
    },
    formCardButtons() {
      return [{
        icon: 'fas fa-save',
        title: this.$i18n_t('Common.save'),
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    }
  },
  watch: {},
  mounted() {
    this.findAlertConfigs();
    this.savedAlertConfigs = cloneDeep(this.alertConfigs);
  },
  methods: {
    findAlertConfigs() {
      Promise.all([ApiService.bridgesGetPlainConfigs('mail'), ApiService.gwMgmtFindAlertConfigs()]).then(res => {
        this.mailBridges = res[0].map(mb => {
          return {
            ...mb,
            uiTitle: `${mb.name} (${this.$i18n_t('Common.tenantId')}: ${mb.tenantId})`
          };
        });
        this.alertConfigs = res[1];
        this.isLoading = false;
        this.savedAlertConfigs = cloneDeep(this.alertConfigs);
      }).catch(error => {
        this.$snack(this.$i18n_t('NiotaClassic.GWMonitoring.snacks.errorGatewayDevice'), 'error');
        console.error(error);
      });
    },
    addNewAlert(index) {
      this.alertConfigs.splice(index + 1, 0, {
        userId: this.$store.state.authentication.user.id,
        email: this.$store.state.authentication.user.email,
        properties: {
          emailSubject: this.$i18n_t('NiotaClassic.GWMonitoring.alertForm.mailSubjectTemplate'),
          emailBody: this.$i18n_t('NiotaClassic.GWMonitoring.alertForm.mailBodyTemplate')
        }
      });
      this.alertConfigs = cloneDeep(this.alertConfigs);
    },
    removeAlert(index) {
      this.deletedConfigs.push(this.alertConfigs[index]);
      pullAt(this.alertConfigs, [index]);
      this.alertConfigs = cloneDeep(this.alertConfigs);
    },
    closeHook() {
      if (!isEqual(this.alertConfigs, this.savedAlertConfigs)) {
        this.unsavedPrompt = true;
        return;
      }
      this.$emit('close');
    },
    saveAlerts() {
      if (this.alertConfigs.length === 0 && this.deletedConfigs.length === 0) {
        this.$emit('close');
        return;
      }
      ApiService.gwMgmtUpdateAlertConfigs({
        configs: this.alertConfigs,
        delete: this.deletedConfigs.filter(c => (c || {}).id)
      }).then(() => {
        this.savedAlertConfigs = cloneDeep(this.alertConfigs);
        this.$snack(this.$i18n_t('NiotaClassic.GWMonitoring.snacks.alertConfigSuccess'), 'success');
      }).catch(error => {
        this.$snack(this.$i18n_t('NiotaClassic.GWMonitoring.snacks.alertConfigFailed'), 'error');
        console.error(error);
      });
    }
  }
};